import { render, staticRenderFns } from "./TemplateCardAttachment.vue?vue&type=template&id=c7cfb7b4&scoped=true&"
import script from "./TemplateCardAttachment.vue?vue&type=script&lang=js&"
export * from "./TemplateCardAttachment.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCardAttachment.vue?vue&type=style&index=0&id=c7cfb7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cfb7b4",
  null
  
)

export default component.exports